import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import * as selectors from 'state/session/selectors';
import { loadScript, removeScript } from 'libs/utils/script';
import { urlWithParams } from 'libs/utils/url';
import { languageCodeToISO } from 'libs/utils/language';
import { RE_CAPTCHA_SITE_KEY } from 'constants/captcha';
import { jsx as _jsx } from "react/jsx-runtime";
const LOADED_CHECK_INTERVAL = 1000;
const CAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js';
const CAPTCHA_SCRIPT_ID = 'captcha-script';

const ReCaptcha = _ref => {
  let {
    onComplete,
    siteKey = RE_CAPTCHA_SITE_KEY
  } = _ref;
  const captchaContainer = useRef(null);
  const {
    0: isRendered,
    1: setIsRendered
  } = useState(false);
  const languageCode = useSelector(selectors.getLanguageCode);
  useEffect(() => {
    async function loadCaptcha() {
      await loadScript({
        id: CAPTCHA_SCRIPT_ID,
        isAsync: true,
        src: urlWithParams(CAPTCHA_SCRIPT_URL, {
          render: 'explicit',
          hl: languageCodeToISO(languageCode)
        })
      });
    }

    loadCaptcha();
    return () => removeScript(CAPTCHA_SCRIPT_ID);
  }, [languageCode]);
  useEffect(() => {
    let interval;

    function callback(key) {
      onComplete(key);
      grecaptcha.reset();
    }

    function renderReCaptcha() {
      var _captchaContainer$cur;

      if (isRendered) return;
      const wrapper = document.createElement('div');
      window.grecaptcha.render(wrapper, {
        sitekey: siteKey,
        callback
      });
      (_captchaContainer$cur = captchaContainer.current) === null || _captchaContainer$cur === void 0 ? void 0 : _captchaContainer$cur.appendChild(wrapper);
      setIsRendered(true);
    }

    function isCaptchaLoaded() {
      return window.grecaptcha && typeof window.grecaptcha.render === 'function';
    }

    function checkIsLoaded() {
      if (!isCaptchaLoaded()) return;
      clearInterval(interval);
      renderReCaptcha();
    }

    if (isCaptchaLoaded()) {
      renderReCaptcha();
    } else {
      interval = setInterval(checkIsLoaded, LOADED_CHECK_INTERVAL);
    }

    return () => clearInterval(interval);
  }, [onComplete, isRendered, setIsRendered, siteKey]);
  return /*#__PURE__*/_jsx("div", {
    className: "u-flexbox u-flex-direction-column u-align-items-center",
    ref: captchaContainer
  });
};

export default ReCaptcha;